import type { CurrencyCode } from '@noths/polaris-client-localisation';
import { priceFormatter } from '@noths/polaris-client-utils';

export const getFormattedPrice = (amount: number, currencyCode: CurrencyCode) => {
  return amount === 0 ? 'FREE' : priceFormatter(currencyCode, amount, false);
};
